import { Button, Flex, Modal, Text } from '@cmpsr/components';

type ModalRenewMembershipProps = {
  isOpen: boolean;
  onCloseClick: () => void;
  onRenewClick: () => void;
};

export default function ModalRenewMembership({ isOpen, onCloseClick, onRenewClick }: ModalRenewMembershipProps) {
  return (
    <Modal isOpen={isOpen} onClose={onCloseClick} isCentered>
      <Modal.Overlay bg="background-overlay" backdropFilter="auto" />
      <Modal.Content
        bg="background-page"
        borderRadius="radii-2"
        border="1px solid"
        borderColor="ui-element-outline-default"
        p={{ base: 'spacer-5', lg: 'spacer-10' }}
        width={{ base: '349px', lg: '603px' }}
        gap="spacer-6"
      >
        <Modal.Header bg="background-page" p={0} textAlign="center">
          <Text variant="text-header-S">
            You are about to{' '}
            <Text as="span" textStyle="text-header-s-v">
              Renew your Membership*
            </Text>
          </Text>
        </Modal.Header>
        <Modal.Footer bg="background-page" flexDirection="column" p={0} gap="spacer-6">
          <Flex flexDirection={{ base: 'column-reverse', lg: 'row' }} gap="spacer-4" width="100%">
            <Button variant="primary-alt" size="m" width={{ base: '100%', lg: '50%' }} onClick={onCloseClick}>
              Cancel
            </Button>
            <Button
              aria-current="step"
              variant="primary"
              size="m"
              width={{ base: '100%', lg: '50%' }}
              onClick={onRenewClick}
            >
              Renew Membership
            </Button>
          </Flex>
          <Text variant="text-body-meta-regular" color="text-secondary" textAlign="center">
            *You will be charged on your annual renewal date using the payment method you selected when you signed up
          </Text>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
}
